import { render, staticRenderFns } from "./MoveInstanceModal.vue?vue&type=template&id=17ab34af&"
import script from "./MoveInstanceModal.vue?vue&type=script&lang=js&"
export * from "./MoveInstanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports